var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "base-control-label",
        { attrs: { label: _vm.lblSetting.ticketOriginOfTheDeclaration } },
        [
          _c("ticket-origin-demand", {
            model: {
              value: _vm.OriginDemand,
              callback: function($$v) {
                _vm.OriginDemand = $$v
              },
              expression: "OriginDemand"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.$route.meta.select_declarant
        ? _c(
            "base-control-label",
            { attrs: { required: "", label: _vm.lblSetting.ticketDeclarer } },
            [
              _c("base-multi-select", {
                attrs: {
                  rules: _vm.dtRules.ticketDeclarerRules,
                  options: _vm.coDeclarant,
                  "item-value": "id",
                  "return-object": true,
                  multiple: false,
                  fetch: _vm.handleGetDeclarants
                },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.Declarant,
                  callback: function($$v) {
                    _vm.Declarant = $$v
                  },
                  expression: "Declarant"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { required: "", label: _vm.lblSetting.ticketName } },
        [
          _c("v-text-field", {
            attrs: {
              counter: "60",
              required: "",
              rules: _vm.dtRules.nameRules
            },
            model: {
              value: _vm.Subject,
              callback: function($$v) {
                _vm.Subject = $$v
              },
              expression: "Subject"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { label: _vm.lblSetting.ticketTypeOfProblem } },
        [
          _c("ticket-group-round-buttons", {
            attrs: { buttons: _vm.typesOfTheProblems },
            model: {
              value: _vm.pbType,
              callback: function($$v) {
                _vm.pbType = $$v
              },
              expression: "pbType"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tenants && _vm.$route.meta.add_tenant
        ? _c(
            "base-control-label",
            {
              attrs: {
                required: _vm.coIsPrivate,
                label: _vm.coIsPrivate
                  ? _vm.lblSetting.ticketFlatmate
                  : _vm.lblSetting.ticketResidentOfTheBuilding
              }
            },
            [
              _c("base-multi-select", {
                attrs: {
                  rules: _vm.coIsPrivate
                    ? _vm.dtRules.ticketFkTicketTenantRules
                    : [],
                  options: _vm.coTenants,
                  "return-object": true,
                  multiple: false,
                  fetch: _vm.handleGetTenants
                },
                on: { change: _vm.handleChangeTenant },
                model: {
                  value: _vm.Tenants,
                  callback: function($$v) {
                    _vm.Tenants = $$v
                  },
                  expression: "Tenants"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { required: "", label: _vm.lblSetting.ticketImmeuble } },
        [
          _c("base-multi-select", {
            attrs: {
              rules: _vm.dtRules.ticketFkTicketBlockRules,
              icon: "icon icon-blocks",
              "item-value": "value",
              options: _vm.coBlocks,
              fetch: _vm.handleFetchBlocks,
              "return-object": false,
              multiple: false
            },
            on: { change: _vm.handleChangeBlock },
            model: {
              value: _vm.FkTicketBlock,
              callback: function($$v) {
                _vm.FkTicketBlock = $$v
              },
              expression: "FkTicketBlock"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.coApartments.length
        ? _c(
            "base-control-label",
            {
              attrs: {
                required: _vm.coIsPrivate,
                label: _vm.lblSetting.ticketAppartement
              }
            },
            [
              _c("base-autocomplete", {
                attrs: {
                  items: _vm.coApartments,
                  "on-fetch-remote": _vm.handleGetApartments,
                  multiple: true,
                  "return-object": false,
                  clearable:
                    _vm.pbType === "internal" || _vm.pbType === "public",
                  rules:
                    _vm.pbType === "public" || _vm.pbType === "internal"
                      ? undefined
                      : _vm.dtRules.ticketFkTicketApartmentRules,
                  "item-value": "value"
                },
                model: {
                  value: _vm.TicketApartments,
                  callback: function($$v) {
                    _vm.TicketApartments = $$v
                  },
                  expression: "TicketApartments"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-control-label",
        {
          attrs: {
            required: "",
            label: _vm.lblSetting.ticketNatureOfTheProblem
          }
        },
        [
          _c("ticket-nature-problem", {
            attrs: { source: _vm.characterProblems.level_1 },
            model: {
              value: _vm.FKTicketCharacterProblem,
              callback: function($$v) {
                _vm.FKTicketCharacterProblem = $$v
              },
              expression: "FKTicketCharacterProblem"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.$route.meta.report_description
        ? _c(
            "base-control-label",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.ticketDescriptionOfTheProblem
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  name: "description",
                  "multi-line": "",
                  box: "",
                  required: "",
                  rules: _vm.dtRules.descriptionRules
                },
                model: {
                  value: _vm.Description,
                  callback: function($$v) {
                    _vm.Description = $$v
                  },
                  expression: "Description"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { label: _vm.lblSetting.ticketAttachDocuments } },
        [
          _c("ticket-upload-buttons", {
            model: {
              value: _vm.vAttachments,
              callback: function($$v) {
                _vm.vAttachments = $$v
              },
              expression: "vAttachments"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.contractors && _vm.$route.meta.mandate && _vm.$route.meta.ask_quote
        ? _c(
            "base-control-label",
            { attrs: { label: _vm.lblSetting.ticketAddASpeaker } },
            [
              _c("ticket-group-round-buttons", {
                attrs: { buttons: _vm.addASpeakers },
                model: {
                  value: _vm.IsMandate,
                  callback: function($$v) {
                    _vm.IsMandate = $$v
                  },
                  expression: "IsMandate"
                }
              }),
              _vm._v(" "),
              _vm.IsMandate
                ? _c("base-multi-select", {
                    attrs: { "return-object": false, options: _vm.contractors },
                    model: {
                      value: _vm.Mandates,
                      callback: function($$v) {
                        _vm.Mandates = $$v
                      },
                      expression: "Mandates"
                    }
                  })
                : _c("base-multi-select", {
                    attrs: { "return-object": false, options: _vm.contractors },
                    model: {
                      value: _vm.Quotes,
                      callback: function($$v) {
                        _vm.Quotes = $$v
                      },
                      expression: "Quotes"
                    }
                  })
            ],
            1
          )
        : _vm.contractors && _vm.$route.meta.mandate
        ? _c(
            "base-control-label",
            { attrs: { label: _vm.lblSetting.ticketAddASpeaker } },
            [
              _c("ticket-group-round-buttons", {
                attrs: { buttons: _vm.addASpeakers },
                model: {
                  value: _vm.IsMandate,
                  callback: function($$v) {
                    _vm.IsMandate = $$v
                  },
                  expression: "IsMandate"
                }
              }),
              _vm._v(" "),
              _c("base-multi-select", {
                attrs: { "return-object": false, options: _vm.contractors },
                model: {
                  value: _vm.Mandates,
                  callback: function($$v) {
                    _vm.Mandates = $$v
                  },
                  expression: "Mandates"
                }
              })
            ],
            1
          )
        : _vm.contractors && _vm.$route.meta.ask_quote
        ? _c(
            "base-control-label",
            { attrs: { label: _vm.lblSetting.ticketAddASpeaker } },
            [
              _c("ticket-group-round-buttons", {
                attrs: { buttons: _vm.addASpeakers },
                model: {
                  value: _vm.IsMandate,
                  callback: function($$v) {
                    _vm.IsMandate = $$v
                  },
                  expression: "IsMandate"
                }
              }),
              _vm._v(" "),
              _c("base-multi-select", {
                attrs: { "return-object": false, options: _vm.contractors },
                model: {
                  value: _vm.Quotes,
                  callback: function($$v) {
                    _vm.Quotes = $$v
                  },
                  expression: "Quotes"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.meta.assign_manager
        ? _c(
            "base-control-label",
            {
              attrs: { required: "", label: _vm.lblSetting.ticketManagerAssign }
            },
            [
              _c("base-multi-select", {
                attrs: {
                  rules: _vm.dtRules.ticketFkTicketManagerRules,
                  options: _vm.coManagers,
                  "return-object": false
                },
                model: {
                  value: _vm.Managers,
                  callback: function($$v) {
                    _vm.Managers = $$v
                  },
                  expression: "Managers"
                }
              }),
              _vm._v(" "),
              _vm.coIsManager && !_vm.coIsAssigned
                ? _c("a", {
                    staticClass: "form-container__button--no-decoration",
                    attrs: { href: "javascript:;", flat: "" },
                    domProps: {
                      textContent: _vm._s(_vm.$t(_vm.lblSetting.ticketAssignMe))
                    },
                    on: { click: _vm.handleAssignMe }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.contractors && _vm.$route.meta.warn_owner
        ? _c(
            "base-control-label",
            { attrs: { label: _vm.lblSetting.ticketNotifyTheOwner } },
            [
              _vm.contractors
                ? _c("ticket-group-round-buttons", {
                    attrs: { buttons: _vm.notifyTheOwners },
                    model: {
                      value: _vm.dtIsNotifyOwner,
                      callback: function($$v) {
                        _vm.dtIsNotifyOwner = $$v
                      },
                      expression: "dtIsNotifyOwner"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.caretakers && _vm.$route.meta.add_caretaker
        ? _c(
            "base-control-label",
            { attrs: { label: _vm.lblSetting.ticketConcierge } },
            [
              _c("base-multi-select", {
                attrs: { "return-object": false, options: _vm.caretakers },
                model: {
                  value: _vm.Caretakers,
                  callback: function($$v) {
                    _vm.Caretakers = $$v
                  },
                  expression: "Caretakers"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bce2a7b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bce2a7b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal/template.html
// module id = null
// module chunks = 